import(/* webpackMode: "eager" */ "/app/apps/no-ga/src/app/global-error.tsx");
